<!-- <template>
    <div id="printPDF">
        
    </div>
</template> -->


<template>
    <div>
        <vue-html2pdf
            :show-layout="false"
            :float-layout="true"
            :enable-download="true"
            :preview-modal="true"
            :paginate-elements-by-height="1400"
            :filename="data.bast_no"
            :pdf-quality="2"
            :manual-pagination="false"
            pdf-format="a4"
            pdf-orientation="portrait"
            pdf-content-width="800px"
            ref="printQrIssued"
        >
            <section slot="pdf-content">
                <surat-pengantar :data="data" />
                

                
            </section>
        </vue-html2pdf>
    </div>
 </template>

<script>

import VueHtml2pdf from 'vue-html2pdf'
import SuratPengantar from './SuratPengantar.vue'


export default {
    props : ['data'],
    methods: {
        /*
            Generate Report using refs and calling the
            refs function generatePdf()
        */
        generateReport() {
            // console.log('%csrc/views/Dashboard/QRCode/QRIssue/children/printReceipt.vue:139 this.$refs.printQrIssued', 'color: #007acc;', this.$refs.printQrIssued);
            this.$refs.printQrIssued.generatePdf()
        }
    },

    components: {
        VueHtml2pdf,
        SuratPengantar
    }
}
</script>